import type { FetchAbadHtmlParams, FetchAbadHtmlResponse } from '../types/@zillow-types';

const fetchAbadHtml = async ({ abadClient, viewer }: FetchAbadHtmlParams) =>
    (await abadClient.fetchHtml(viewer?.zuid)) as Promise<FetchAbadHtmlResponse>;

export default fetchAbadHtml;
